import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { validateApiKey, removeApiKey, getApiKeyStatus } from './api-key.api';
import type {
  ValidateApiKeyRequest,
  RemoveApiKeyRequest,
} from '@shared/types/dashboard';

export const useApiKeyStatus = (shop: string) => {
  return useQuery({
    queryKey: ['apiKeyStatus', shop],
    queryFn: () => getApiKeyStatus(shop),
    enabled: !!shop,
  });
};

export const useValidateApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: ValidateApiKeyRequest) => validateApiKey(request),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['apiKeyStatus', variables.shop] });
    },
  });
};

export const useRemoveApiKey = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: RemoveApiKeyRequest) => removeApiKey(request),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['apiKeyStatus', variables.shop] });
    },
  });
};

